import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
  Fieldset,
  Legend,
  Badge,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import Shimmer from "react-shimmer-effect";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";
import DetailBloc from "./Blocs/DetailBloc";
import LoadingComponent from "./Components/LoadingComponent";

class IndexView extends Component {
  detailBloc = new DetailBloc();

  queryParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      birthNational: "",
    };
  }

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseYMD = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("YYYY-MM-DD");
    }
    return res;
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  submitData = async () => {};

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        uuid: this.state.dataForm.cp3k_uuid,
      },
      confirm: true,
    });
  };

  rupiah = (num) => {
    let res = "-";
    if (num != null && num != "") {
      res = parseFloat(num).toLocaleString("id-ID", {
        maximumFractionDigits: 2,
      });
    }
    return res;
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loadingDetail: true,
          });
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;

            // load to form
            this.setState({
              dataForm: response,
              birthNational: response.cp3k_candidate_place_of_birth_national,
              document: response.document_sk,
              // document_spmt: response.document_spmt,
              document_plan_letter: response.document_plan_letter,
              document_contract: response.document_contract,
              document_kk: response.document_kk,
              document_akta_anak: response.document_akta_anak,
              document_akta_nikah: response.document_akta_nikah,
              document_bank: response.document_bank,
              document_npwp: response.document_npwp,
              loadingDetail: false,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.detailBloc.fetchDetail({ uuid: this.queryParams.get("uuid") });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Detail Calon PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    {/* Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi. */}
                  </CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Penetapan NIP BKN
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_number"
                          placeholder="Nomor"
                          errorMessage="Masukkan Nomor"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_bkn_confirmation_number
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_bkn_confirmation_date"
                          placeholder="Tanggal"
                          errorMessage="Masukkan Tanggal"
                          type="date"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_bkn_confirmation_date
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Lengkap
                      </Label>
                      <Col md="4">
                        <AvField
                          name="cp3k_candidate_name"
                          placeholder="Nama"
                          errorMessage="Masukkan Nama"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_full_name}
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Email BKPM
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_email"
                          placeholder="Email BKPM"
                          errorMessage="Masukkan Email BKPM"
                          type="email"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_email}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor HP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_phone_number"
                          placeholder="Nomor HP"
                          errorMessage="Masukkan Nomor HPP"
                          type="number"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_phone_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIK</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_nik"
                          placeholder="NIK"
                          errorMessage="Masukkan NIK"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_nik}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor KK
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_familiy_card_number"
                          placeholder="Nomor KK"
                          errorMessage="Masukkan Nomor KK"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_familiy_card_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor NPWP
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_npwp_number"
                          placeholder="Nomor NPWP"
                          errorMessage="Masukkan Nomor NPWP"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_npwp_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">NIP</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_nip"
                          placeholder="NIP"
                          errorMessage="Masukkan NIP"
                          type="text"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_nip}
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tempat Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          type="text"
                          className="form-control"
                          value={this.state.birthNational}
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_country_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_country_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? {}
                          : { display: "none" }
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_province_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_province_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_place_of_birth_city_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_city_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row
                      className="mb-3"
                      style={
                        this.state.birthNational == "Dalam Negeri"
                          ? { display: "none" }
                          : {}
                      }
                    >
                      <Label className="col-md-3 col-form-label"></Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_place_of_birth_national"
                          placeholder="Kota..."
                          type="text"
                          errorMessage="Masukkan Kota"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_place_of_birth_city_text
                          }
                          validate={{
                            required: {
                              value:
                                this.state.birthNational == "Dalam Negeri"
                                  ? false
                                  : true,
                            },
                          }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Kode Pos
                      </Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_postal_code"
                          placeholder="Kode Pos"
                          errorMessage="Masukkan Kode Pos"
                          type="number"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_postal_code
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Alamat</Label>
                      <Col md="5">
                        <AvField
                          name="cp3k_candidate_address"
                          placeholder="Alamat"
                          errorMessage="Masukkan Alamat"
                          type="textarea"
                          className="form-control"
                          value={this.state.dataForm?.cp3k_candidate_address}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Tanggal Lahir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_date_of_birth"
                          placeholder="Tanggal Lahir"
                          errorMessage="Masukkan Tanggal Lahir"
                          type="date"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_date_of_birth
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Jenis Kelamin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_gender_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_gender_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Status Kawin
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_marital_status_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_marital_status_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Pendidikan Terakhir
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_last_education_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_last_education_major"
                          placeholder="Program Studi / Jurusan"
                          errorMessage="Masukkan Program Studi"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_last_education_major
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Golongan
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_rank_name"
                          type="text"
                          className="form-control"
                          value={`${this.state.dataForm?.cp3k_candidate_rank_name}`}
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Jabatan</Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_position_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_position_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Unit Kerja
                      </Label>
                      <Col md="6">
                        <AvField
                          name="cp3k_candidate_work_unit_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_work_unit_name
                          }
                          validate={{ required: { value: true } }}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Bank</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_account_bank_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nomor Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_bank_number"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm
                              ?.cp3k_candidate_account_bank_number
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Nama Rekening
                      </Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_account_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_account_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">Agama</Label>
                      <Col md="3">
                        <AvField
                          name="cp3k_candidate_religion_name"
                          type="text"
                          className="form-control"
                          value={
                            this.state.dataForm?.cp3k_candidate_religion_name
                          }
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK Calon PPPK
                      </label>
                      <Col md="3">
                        <AvField
                          name="cp3k_decree_number"
                          id="cp3k_decree_number"
                          placeholder="Nomor SK Calon PPPK"
                          type="text"
                          errorMessage="Masukan Nomor SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.dataForm?.cp3k_decree_number}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal SK Calon PPPK
                      </label>
                      <Col md="2">
                        <AvField
                          name="cp3k_decree_date"
                          id="cp3k_decree_date"
                          placeholder="Tanggal SK Calon PPPK"
                          type="date"
                          errorMessage="Masukan Tanggal SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.dateParseYMD(
                            this.state.dataForm?.cp3k_decree_date
                          )}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT SK Calon PPPK
                      </label>
                      <Col md="2">
                        <AvField
                          name="cp3k_decree_tmt_date"
                          id="cp3k_decree_tmt_date"
                          placeholder="TMT SK Calon PPPK"
                          type="date"
                          errorMessage="Masukan TMT SK Calon PPPK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.dateParseYMD(
                            this.state.dataForm?.cp3k_decree_tmt_date
                          )}
                          disabled={true}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File SK Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={this.state.document?.documents_path}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File SPMT Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.document_spmt ? (
                          <>
                            {this.state.document_spmt !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={this.state.document_spmt?.documents_path}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "30%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Surat Pernyataan Rencana Penempatan Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_plan_letter !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={
                                  this.state.document_plan_letter
                                    ?.documents_path
                                }
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>
                    {/* 
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Kontrak Kerja Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_contract !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={
                                  this.state.document_contract?.documents_path
                                }
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File KARTU Keluarga Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_kk !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={this.state.document_kk?.documents_path}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Akta Anak Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_akta_anak !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={
                                  this.state.document_akta_anak?.documents_path
                                }
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Akta Nikah Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_akta_nikah !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={
                                  this.state.document_akta_nikah?.documents_path
                                }
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File Bank Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_bank !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={this.state.document_bank?.documents_path}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        File NPWP Calon PPPK
                      </Label>
                      <Col md="6">
                        {this.state.loadingDetail == true ? (
                          <LoadingComponent></LoadingComponent>
                        ) : (
                          <>
                            {this.state.document_npwp !== null ? (
                              <a
                                target={"_blank"}
                                className="btn btn-sm btn-success"
                                href={this.state.document_npwp?.documents_path}
                              >
                                Download <i className="fa fa-download ms-1"></i>
                              </a>
                            ) : (
                              <Badge className="badge bg-danger font-size-14">
                                {" "}
                                Tidak Ada Dokumen
                              </Badge>
                            )}
                          </>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link
                          to={`/kepegawaian/cp3k.html?create_cp3k&uuid=${this.queryParams.get(
                            "period_uuid"
                          )}`}
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={`/kepegawaian/cp3k.html?create_cp3k&uuid=${this.queryParams.get(
              "period_uuid"
            )}`}
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
